import { render, staticRenderFns } from "./TicketContactAdd.vue?vue&type=template&id=7b8b9b04&"
import script from "./TicketContactAdd.vue?vue&type=script&lang=js&"
export * from "./TicketContactAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports